import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=d8ccb10a"
import script from "./Admin.js?vue&type=script&lang=js&external"
export * from "./Admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports